// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__ustZF","col":"CardReaderDesc_col__1AUG-","label":"CardReaderDesc_label__3HDS3"};